module.exports = __webpack_public_path__ + "img/hand-heart.d92809ba.png";